export default class ExcusedAbsenceService {
    static fromJson(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate), excusedAbsencePeriods: json.excusedAbsencePeriods.map(
            // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'startDate' implicitly has an 'any' type. | TS7031 - Binding element 'endDate' implicitly has an 'any' type.
            ({ id, startDate, endDate }) => {
                const period = { id };
                if (startDate) {
                    period.startDate = new Date(startDate);
                }
                if (endDate) {
                    period.endDate = new Date(endDate);
                }
                return period;
            }) });
    }
}
